"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Teller_1 = require("../../../../DriveScout/Billing/Teller");
var Product_1 = require("../../../classes/Product");
var removeNulls_1 = __importDefault(require("../../../common/helpers/removeNulls"));
var CouponsController = /** @class */ (function () {
    function CouponsController(CouponsModel, ProductsModel, FlashService, $window) {
        var _this = this;
        this.CouponsModel = CouponsModel;
        this.FlashService = FlashService;
        this.inDollars = Teller_1.inDollars.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.deleteCoupon = this.deleteCoupon.bind(this);
        this.loading = false;
        this.$window = $window;
        this.forms = {
            createCoupon: {
                coupon: {},
            },
            editCoupon: {
                coupon: {},
                product: {},
            },
        };
        this.products = [];
        this.coupons = [];
        this.options = {
            valid: [
                { name: "Valid", value: 1 },
                { name: "Invalid", value: 0 },
                //needs to be 0 and 1 instead of true/false for laravel validator on backend
            ],
        };
        this.search = {};
        CouponsModel.get().then(function (response) {
            _this.coupons = response.coupons;
        });
        ProductsModel.get({ paging: false, disabled: 0 }).then(function (response) {
            _this.products = response.products.data.map(function (product) { return new Product_1.Product(product); });
        });
        this.updateCouponStart = this.updateCouponStart.bind(this);
        this.updateCouponEnd = this.updateCouponEnd.bind(this);
        this.searchCoupons = this.searchCoupons.bind(this);
    }
    CouponsController.prototype.openModal = function (coupon) {
        this.forms.editCoupon.coupon = Object.assign(coupon);
        this.modalShown = true;
    };
    CouponsController.prototype.closeModal = function () {
        this.modalShown = false;
        this.forms.editCoupon.coupon = {}; //reset
        this.forms.editCoupon.product = {}; //reset
    };
    CouponsController.prototype.deleteCoupon = function (coupon, index) {
        var _this = this;
        var confirm = this.$window.confirm("Are you sure you want to delete this coupon?");
        if (confirm === false) {
            return;
        }
        this.CouponsModel.destroy(coupon).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.coupons = _this.coupons.filter(function (c) {
                return c.id !== coupon.id;
            });
        });
    };
    CouponsController.prototype.addProductToCoupon = function () {
        var _this = this;
        var coupon = Object.assign(this.forms.editCoupon.coupon);
        var product = Object.assign(this.forms.editCoupon.product.$originalData);
        this.CouponsModel.addProduct(coupon, product).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.closeModal();
            _this.coupons = _this.coupons.map(function (coupon) {
                if (coupon.id === response.coupon.id) {
                    return response.coupon;
                }
                return coupon;
            });
        });
    };
    CouponsController.prototype.removeProduct = function (coupon, product) {
        var _this = this;
        var confirm = this.$window.confirm("Are you sure you want to remove this product from this coupon?");
        if (confirm === false) {
            return;
        }
        this.CouponsModel.removeProduct(coupon, product).then(function (response) {
            _this.FlashService.setMessage({
                type: "success",
                message: response.message,
            });
            _this.closeModal();
            _this.coupons = _this.coupons.map(function (coupon) {
                if (coupon.id === response.coupon.id) {
                    return response.coupon;
                }
                return coupon;
            });
        });
    };
    CouponsController.prototype.createCoupon = function () {
        var _this = this;
        this.loading = true;
        var coupon = Object.assign({}, this.forms.createCoupon.coupon);
        if (coupon.type === "fixed") {
            coupon.amount = coupon.amount * 100;
        }
        if (coupon.min_spend && coupon.min_spend > 0) {
            coupon.min_spend = coupon.min_spend * 100;
        }
        else {
            delete coupon.min_spend;
        }
        if (coupon.max_spend && coupon.max_spend > 0) {
            coupon.max_spend = coupon.max_spend * 100;
        }
        else {
            delete coupon.max_spend;
        }
        this.CouponsModel.create(coupon).then(function (response) {
            _this.loading = false;
            coupon.valid = true;
            _this.coupons.push(response.coupon);
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
            _this.forms.createCoupon.coupon = {};
        });
    };
    CouponsController.prototype.updateCouponStart = function (newDate) {
        this.forms.createCoupon.coupon.start = newDate.selected[0];
    };
    CouponsController.prototype.updateCouponEnd = function (newDate) {
        this.forms.createCoupon.coupon.end = newDate.selected[0];
    };
    CouponsController.prototype.toggleCouponValid = function (coupon) {
        var _this = this;
        this.CouponsModel.update({ id: coupon.id, valid: !coupon.valid }).then(function (response) {
            _this.loading = false;
            coupon.valid = !coupon.valid;
            _this.FlashService.setMessage({
                message: response.message,
                type: "success",
            });
        });
    };
    CouponsController.prototype.getSearchParams = function (removeNulls) {
        var _a;
        if (removeNulls === void 0) { removeNulls = true; }
        var params = {
            couponCode: this.search.code ? this.search.code : null,
            valid: ((_a = this.search.valid) === null || _a === void 0 ? void 0 : _a.value) !== undefined
                ? Boolean(this.search.valid.value)
                : null,
        };
        if (removeNulls === true) {
            return (0, removeNulls_1.default)(params);
        }
        return params;
    };
    CouponsController.prototype.searchCoupons = function () {
        var _this = this;
        this.loading = true;
        this.CouponsModel.get(this.getSearchParams()).then(function (response) {
            _this.coupons = response.coupons;
            _this.loading = false;
        });
    };
    return CouponsController;
}());
CouponsController.$inject = [
    "CouponsModel",
    "ProductsModel",
    "FlashService",
    "$window",
];
exports.default = CouponsController;
